module.exports = __webpack_public_path__ + "img/Frame 1010five.7432c385.png";